export default __webpack_public_path__ + "static/media/icon-filter.65ef1b04.svg";